import fetch from 'isomorphic-fetch'

function createHeaders(headers) {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...headers,
  }
}

export interface IHttpError {
  message: string
  statusCode: number
}
class HttpError extends Error {
  statusCode: number

  constructor(message: string, statusCode: number) {
    super(message)
    this.statusCode = statusCode
    this.name = 'HttpError'
  }
}

/**
 * @todo Add OAuth Bearer authenficiation support
 *
 * @param path Example: `/api/session` or `/session`
 * @param options
 * @param localError
 */
async function fetchAPI(
  path: string,
  options: any = {},
  localError = false,
): Promise<Record<string, any>> {
  try {
    const response = await fetch(path, {
      credentials: 'include',
      ...options,
      headers: createHeaders(options.headers),
    })

    const contentType = response.headers.get('content-type') || ''
    const result = contentType.includes('application/json')
      ? await response.json()
      : { error: await response.text() }

    if (!response.ok) {
      const statusCode = response.status

      // Module inactive — special handling
      if (
        statusCode === 403 &&
        Array.isArray(result?.errors) &&
        result.errors.some((e: any) => e?.code === 'MODULE_INACTIVE')
      ) {
        const err = new HttpError('MODULE_INACTIVE', statusCode)
        ;(err as any).code = 'MODULE_INACTIVE'
        ;(err as any).module = result.errors.find((e: any) => e?.code === 'MODULE_INACTIVE')?.module
        throw err
      }

      // Для 400 ошибок возвращаем результат с ошибками, чтобы можно было обработать на клиенте
      if (localError) {
        const getMessage = (): string => {
          const message = result?.errors || result?.error || result?.incompleteWorks
          if (typeof message === 'string') {
            return message
          }
          if (Array.isArray(message)) {
            return message.join(',')
          }
          return 'Неизвестная ошибка'
        }
        return {
          error: {
            statusCode,
            message: getMessage(),
          },
        }
      }
      if (statusCode === 400 && (result?.errors || result?.error || result?.incompleteWorks)) {
        return result
      }
      if (!result?.message) {
        const fromErrors =
          Array.isArray(result?.errors) && result.errors.length
            ? result.errors
                .map((e: { detail?: string; message?: string }) => e?.detail || e?.message || '')
                .filter(Boolean)
                .join('. ')
            : ''
        throw new HttpError(fromErrors || result?.error || 'Неизвестная ошибка', statusCode)
      }
    }

    if (!result) {
      if (localError) {
        return {
          error: {
            message: 'Ответ не получен',
          },
        }
      }
      throw new Error('Empty response received')
    }

    return result
  } catch (e) {
    console.log({ localError, e })
    if (localError) {
      return {
        error: {
          message: 'Ответ не получен, повторите попытку позже',
        },
      }
    } else {
      console.error(e)
      throw e
    }
  }
}

export default fetchAPI
